import { Button } from "antd";
import classNames from "classnames";
import { EditIcon } from "components/Icons";
import React from "react";

const EditIconButton = React.memo(function EditIconButton(props) {
  return (
    <Button
      size="small"
      type="text"
      style={{ padding: "0 2px" }}
      className={classNames("m-l-xs",props.className)}
      {...props}
    >
      <EditIcon />
    </Button>
  );
});

export default EditIconButton;
